import { Phone } from "lucide-react";
import { LogoMark } from "./Logo";

export const Footer = ({ onBook }) => (
  <footer className="border-t border-gold/15 bg-navy-950">
    <div className="mx-auto max-w-7xl px-5 py-16 lg:px-8">
      <div className="flex flex-col items-start justify-between gap-10 lg:flex-row lg:items-center">
        <div className="flex items-center gap-4">
          <LogoMark size={48} />
          <div>
            <div className="font-display text-xl font-bold text-slate-50">HEIDARI <span className="text-gold">LAW GROUP</span></div>
            <p className="mt-1 max-w-sm text-sm text-slate-400">
              3530 Wilshire Blvd. Suite 710, Los Angeles, CA 90010
            </p>
          </div>
        </div>
        <div className="flex flex-col gap-3 sm:flex-row sm:items-center">
          <a href="tel:+14172831384" className="flex items-center gap-2 font-mono text-lg text-gold hover:text-gold-champagne">
            <Phone size={18} /> (417) 283-1384
          </a>
          <button
            data-testid="footer-book-btn"
            onClick={onBook}
            className="btn-sheen rounded-full bg-gradient-to-r from-[#D4AF37] to-[#B38F32] px-6 py-3 text-sm font-bold text-navy-950 shadow-lg shadow-gold/20 transition-all hover:from-[#E6CA65] active:scale-[0.98]"
          >
            Book Free Consultation
          </button>
        </div>
      </div>
      <div className="gold-hairline my-10" />
      <div className="flex flex-col justify-between gap-4 text-xs text-slate-500 sm:flex-row">
        <p>© {new Date().getFullYear()} Heidari Law Group. All rights reserved. Attorney Advertising. Prior results do not guarantee a similar outcome.</p>
        <a href="/admin" data-testid="admin-link-nav" className="font-mono tracking-widest text-gold/50 uppercase transition-colors hover:text-gold">
          Staff Login
        </a>
      </div>
    </div>
  </footer>
);
